/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import ReactMarkdown from "react-markdown";
import { BEM } from "@adapptio/lib-components";
import { ReactMarkdownOptions } from "react-markdown/lib/react-markdown";

export interface IMarkdownProps extends ReactMarkdownOptions {
	className?: string;
}

export const Markdown: React.FC<IMarkdownProps> = ({ className, children, ...props }) => {
	const baseClass = BEM("edt-markdown");

	if (className) {
		baseClass.add(className);
	}

	return (
		<ReactMarkdown className={baseClass.toClassName()} {...props}>
			{children}
		</ReactMarkdown>
	);
};
